var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { resets } from "@recoil/Store";
import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import * as Const from "@utils/Const";
export default function MenuView(props) {
    const { item, setItem } = props;
    const setReset = useSetRecoilState(resets);
    let token = localStorage.getItem(Const.TOKEN);
    const [items, setItems] = useState(null);
    let menuId = item.depth2 ? item.depth2.menuId : item.depth1.menuId;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/admin/menu/${menuId}`,
        appQuery: {},
        userToken: token,
        watch: menuId,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setItems(data.body);
            }
        }
    }, [data]);
    const handleView = (type) => {
        setItem(Object.assign(Object.assign({}, item), { type: type }));
    };
    const handleDel = () => __awaiter(this, void 0, void 0, function* () {
        var isOk = confirm(`해당 메뉴를 삭제하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_DELETE,
            appPath: `/admin/menu/${items.menuId}`,
            appQuery: {},
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert("삭제되었습니다.");
                location.reload();
            }
            else {
                alert(data.body.message);
            }
        }
    });
    return (_jsx(_Fragment, { children: items &&
            _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsx("h2", { children: "\uBA54\uB274 \uC0C1\uC138" }), items.depth > 1 &&
                        _jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC0C1\uC704ID" }), _jsx("input", { type: "text", disabled: true, value: items.parent.menuId || "" })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC0C1\uC704 \uBA54\uB274" }), _jsx("input", { type: "text", disabled: true, value: items.parent.menuName || "" })] }))] }), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "ID" }), _jsx("input", { type: "text", disabled: true, value: items.menuId || "" })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uBA54\uB274\uBA85" }), _jsx("input", { type: "text", disabled: true, value: items.name || "" })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "URL" }), _jsx("input", { type: "text", disabled: true, value: items.url || "" })] })), _jsxs("div", Object.assign({ className: "footer-row" }, { children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "active", disabled: !items.isActive ? true : false, checked: items.isActive, readOnly: true }), " \uBA54\uB274 \uD65C\uC131\uD654"] }), _jsxs("div", Object.assign({ className: "btn-group" }, { children: [_jsx("button", Object.assign({ className: "edit-btn", onClick: () => handleView(Const.TYPE_P) }, { children: "\uC218\uC815" })), _jsx("button", Object.assign({ className: "delete-btn", onClick: handleDel }, { children: "\uC0AD\uC81C" }))] }))] }))] })) }));
}
